export const venueReportCsvOneVenueSentence = count =>
  Number(count) > 1 ? 'This file is for one venue.' : ''

export const canDownloadVenueReportCsv = count => Number(count) === 1

export const VENUE_REPORT_CSV_GROUP_ASK = 'Which venue from this group?'

export const VENUE_REPORT_CSV_GROUP_PLACEHOLDER = 'Select a venue'

export const shouldAskVenueReportCsvGroup = venueIds =>
  (venueIds || []).length > 1
